import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { t } from 'i18next'
import drillIcon from 'Assets/Images/Generals/drill.svg'
import { CustomDropdownSelector } from './CustomDropdownSelector'
import './serviceCard.css'
import ToolTipInformation from 'Components/ToolTipInformation/ToolTipInformation'
import { NO_INSTALLATION_OPTION } from 'Utils/constants'
import { useInstallationServices } from 'Hooks/useInstallationServices'
import { addOrIncrementServiceInCart } from 'Utils/Helpers/cartInstallationHelpers'

const ServiceCard = ({
  title = t('INSTALLATION_SERVICE_T.ADD_INSTALLATION_SERVICE'),
  icon = drillIcon,
  services = [],
  cardStyle = {},
  titleStyle = {},
}) => {
  const dispatch = useDispatch()

  const { servicesData, selectedServices, selectService, cart } =
    useInstallationServices(services)

  const handleSelect = async item => {
    selectService(item)
    await addOrIncrementServiceInCart(dispatch, cart, item)
  }

  const effectiveSelectedServices =
    selectedServices.length === 0 ? [NO_INSTALLATION_OPTION] : selectedServices

  return (
    <div className="service-card" style={cardStyle}>
      <div className="service-card__header">
        <img src={icon} alt="service icon" className="service-card__icon" />
        <p className="service-card__title" style={titleStyle}>
          {title}
        </p>
        <ToolTipInformation
          message={
            <div>
              <p style={{ fontSize: '12px' }}>
                Selecciona el tipo de instalación o reemplazo según el lugar
                donde se va a realizar (casa, departamento,etc)
              </p>
            </div>
          }
        />
      </div>

      <CustomDropdownSelector
        label={NO_INSTALLATION_OPTION.name}
        value={effectiveSelectedServices}
        options={servicesData}
        onSelect={handleSelect}
        getOptionLabel={item => item.name}
        getOptionValue={item => item.productId}
        name="services-selector"
        unselectableOption={NO_INSTALLATION_OPTION}
      />
    </div>
  )
}

ServiceCard.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  services: PropTypes.arrayOf(PropTypes.object).isRequired,
  cardStyle: PropTypes.object,
  titleStyle: PropTypes.object,
}

export default React.memo(ServiceCard)
